module.exports = __webpack_public_path__ + "static/media/logo-new.c3687609.png";